import { configureStore, Tuple } from '@reduxjs/toolkit'
import reducers from 'app/reducers/root-reducers'
import rootSaga from "app/sagas/root-saga"
import createSagaMiddleware from 'redux-saga'
const sagaMiddleware = createSagaMiddleware()

const store = configureStore({
    reducer: reducers,
    devTools: ['dev', 'local'].includes(process.env.APP_ENV),   //process.env.NODE_ENV !== 'production'
    middleware: () => new Tuple(sagaMiddleware),
})

sagaMiddleware.run(rootSaga)

export default store